<template>
  <div>
    <el-table
      class="BlackList"
      :data="tableData"
    >
      <el-table-column prop="rank" label="#" sortable min-width="15%"></el-table-column>
      <el-table-column prop="name" label="Name">
        <template slot-scope="scope">
          <Name :name="scope.row.name" :logo="scope.row.logo" :href="scope.row.website"/>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="Node Address">
        <template slot-scope="scope">
          <a href="#">{{scope.row.address}}</a>
        </template>
      </el-table-column>
      <el-table-column prop="country" label="Country/Area"
                       align="right" min-width="20%"></el-table-column>
    </el-table>
  </div>
</template>
<script>
  import Name from './tablecell/Name';

  export default {
    name: 'BlackList',
    components: { Name },
    props: {
      tableData: Array,
    },
  };
</script>
